import {getFileVerification} from '@/services/fileUploadService'
import {uploadSuggestedSKUsService} from '@/services/uploadFile'
import {useCallback} from 'react'
import {useAppDispatch} from '@/store'
import {setToastNotifications} from '@/store/slices/commonSlice'
import {useState} from 'react'
import {useAzureBlob} from '@/hooks/useAzureBlob-hook'
import {Constants} from '@/utils/constants/commonConstants'
import {downloadCsvFromCdnUrl} from '@/helpers/shadcn/utils'
import {getSuggestedSkuFile} from '@/services/ProductsService/SuggestedSku/suggestedSku'

export const useSuggestedSKU = () => {
  const dispatch = useAppDispatch()
  const [showSKUModal, setShowSKUModal] = useState(false)
  const [formData, setFormData] = useState({})
  const {uploadFileOnBlob} = useAzureBlob()

  const formatErrorMessage = message => {
    if (!message) return message
    return (
      <div>
        {message.split(';').map((msg, index) => (
          <p key={index}>{msg}</p>
        ))}
      </div>
    )
  }

  const uploadSuggestedSKUFile = useCallback(
    async (onCloseModal, setUploading, setFeedback, file) => {
      if (!file) return

      setUploading(true)

      try {
        const formData = new FormData()
        formData.file = file

        const templateResponse = await getFileVerification(formData, Constants.uploadSuggestedSKUs, true)

        if (!templateResponse || templateResponse.success === false || Object.keys(templateResponse).length === 0) {
          setFeedback(templateResponse?.message ?? 'File verification failed.')
          return
        }

        if (!templateResponse?.blobUrl) {
          setFeedback('Unexpected response from server.')
          return
        }

        const renamedFile = new File([file], templateResponse.fileName, {type: file.type})
        const blobResponse = await uploadFileOnBlob(templateResponse, renamedFile)
        if (blobResponse !== true) {
          setFeedback('Blob upload failed.')
          return
        }

        const result = await uploadSuggestedSKUsService({
          data: {
            blobPath: templateResponse.blobUrl,
          },
        })

        dispatch(
          setToastNotifications({
            show: true,
            message: `Suggested SKU's Successfully Published`,
            type: 'success',
          })
        )

        if (!result || result.success === false) {
          setFeedback(formatErrorMessage(result?.data?.message) ?? 'An error occurred during file upload.')
          return
        }

        onCloseModal?.()
      } catch (err) {
        setFeedback(formatErrorMessage(err?.data?.message) ?? 'An error occurred during file upload.')
      } finally {
        setUploading(false)
      }
    },
    [dispatch, uploadFileOnBlob]
  )

  const downloadSuggestedSKUTemplate = async countryCode => {
    const res = await getSuggestedSkuFile()
    if (res && res.cdnUrl) downloadCsvFromCdnUrl(res.cdnUrl, 'Suggested_SKU_Template.csv')
  }

  return {
    uploadSuggestedSKUFile,
    downloadSuggestedSKUTemplate,
    showSKUModal,
    setShowSKUModal,
    setFormData,
    formData,
  }
}
